<template>
  <div :data-testid="dataTestid"
       :class="$attrs.class || appendClass"
       :id="random_id"
  >
    <slot>
      <TsCard :appendClass="twMerge(`rounded-${roundness} bg-[#eaecf9] p-0 shadow-none`,props.contentClass)">
        <div :class="twMerge('flex gap-5',props.descriptionClass)">
          <slot name="image">
            <TsImage class="rounded-full object-cover w-20 h-20" :src="image" :alt="alt" loading="lazy"/>
          </slot>
          <slot name="description">
             <span class="text-natural-grey dark:text-gray-400 py-2 font-medium">
              <TsTypography :text="description"/>
              </span>
          </slot>
        </div>
      </TsCard>
    </slot>
  </div>
</template>


<script setup lang="ts">

import {onMounted, ref} from "vue";
import {twMerge} from "tailwind-merge";
import {useRandomUUID} from "~/composables/useRandomUUID";

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

enum Sizes {
  Xs = "xs",
  Sm = "sm",
  Md = "md",
  Xl = "xl",
  XXl = "2xl",
  Full = "full",
}

type Props = {
  alt?: string | number,
  image?: string,
  description?: string,
  roundness: Sizes,
  dataTestid?: string,
  appendClass?: string,
  contentClass:string;
  descriptionClass:string;
}
// @ts-ignore
const props = withDefaults(defineProps<Props>(), {
  image: '/images/cardImage.webp',
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi nulla dolor, eleifend vitae.',
  roundness: Sizes.Full
});

const random_id = ref("");
onMounted(() => {
  random_id.value = useRandomUUID();
});

</script>

